import AlertDialog from "./AlertDialog";

// Export without redux connection
export default AlertDialog;
